(function() {
'use strict';

angular
    .module('dashboard')
    .controller('PayBalance', PayBalance);

function PayBalance(
    $scope,
    $q,
    $routeParams,
    $location,
    $timeout,
    broker,
    rootPath,
    dashboardBookingService,
    paymentDetailsService,
    paymentsService,
    paymentsUtilService,
    resourceService,
    urlUtils,
    mybTrack,
    currentUser) {
    const cm = this;
    let threeDSecure = null;

    const root = urlUtils.getOrigin() + rootPath.getRootPath();
    const completeUrl = 'dashboard/pay-balance/complete/{0}';
    const bookingReferenceUrl = 'dashboard/bookings/reference/{0}';
    const payPalCallbackUrl = '{0}paybalancepaypalcallback?paymentId={1}&bookingId={2}&ppResp={3}';
    const cpgStatusApiEnabled = TRPCONFIG.Domain.CpgStatusApiEnabled;
    const cpgStatusStartPollingDelay = TRPCONFIG.Domain.CpgStatusStartPollingDelay;

    cm.bookingId = parseInt($routeParams.bookingId);
    cm.threedsRedirecting = false;
    cm.payFull = true;

    mybTrack.track('MYB - Open Pay Balance', {
        ReferralMethod: $routeParams.ReferralMethod
    });

    cm.paymentModel = paymentsUtilService.createEmptyPaymentModel();

    dashboardBookingService.getBookingInfo(cm.bookingId).then(function(booking) {
        cm.bk = booking;
    });

    //Get booking detail for the common ManageHeader
    dashboardBookingService.getBookingDetail(cm.bookingId).then(function(data) {
        _processBalanceDue(data.BalanceDueInfo);
        cm.isPartOfHoliday = data.IsPartOfHoliday;

        //getsavedbookingcards is obsolete now. So calling get and joining with PaymentOptions
        const getOptions = paymentDetailsService.getPaymentOptions(data.Booking.Type, cm.bookingId, data.BalanceDueInfo.ClientCurrencyCode);
        const getCards = TRPCONFIG.Domain.SavedCardsEnabled && $scope.user.HardSignedIn ? paymentDetailsService.getPaymentCards() : null;

        $q.all([getOptions, getCards]).then(function(results) {
            cm.paymentOptions = paymentsUtilService.convertMybPaymentOptions(results[0]);
            if (results[1]) {
                cm.savedCards = paymentsUtilService.convertMybSavedCards(results[1], results[0]);
            }

            cm.dataLoaded = true;
        });

        if ($routeParams.ppResp) {
            _showError(resourceService.get(paymentsService.getPayPalResponseMessage([$routeParams.ppResp])));
        }
    });
    cm.preBookCommands = [];

    cm.addPreBookCommand = command => {
        if (!cm.preBookCommands.includes(command)) {
            cm.preBookCommands.push(command);
        }
    };

    cm.generateTokens = () => {
        return paymentsService.generateTokens(
            cm.paymentModel.cardDetail.expiryDate.month,
            cm.paymentModel.cardDetail.expiryDate.year,
            cm.paymentModel.saveCard
         );
    };

    cm.addPreBookCommand(cm.generateTokens);

    cm.executePrebookCommands = () => {
        return Promise.all(cm.preBookCommands.map(preBookCommand => preBookCommand()));
    };

    cm.makePayment = function() {
        const expires = cm.paymentModel.cardDetail.expiryDate;
        const today = new Date();

        if (expires &&
            expires.year
            && expires.month
            && expires.year <= today.getFullYear()
            && expires.month < (today.getMonth() + 1)) {
                _showError(resourceService.get('CARDHASEXPIRED'));
            return;
        }

        if (sessionStorage.getItem('PaymentPopup')) {
            _block(true);
            setTimeout(() => {
                sessionStorage.removeItem('PaymentPopup');
            }, 200);
        }
        const requireValidation = cm.paymentModel.cardDetail.isSavedCard === false
            && cm.paymentModel.isPayPalPayment === false
            && cm.paymentModel.externalFop === undefined;

        paymentDetailsService.clearPayment(_formatClearRequestPayload(), requireValidation).then(function(result) {
            if (result.Success) {
                if (result.AcsRedirectRequired) {
                    if (cm.paymentModel.isPayPalPayment) {
                        //Paypal redirection
                        window.location = result.AcsUrl;
                    } else {
                        //3ds redirection
                        if (cpgStatusApiEnabled) {
                            $timeout(() => {
                                cpgValidationComplete(cm.bookingId, result.PaymentId);
                            }, cpgStatusStartPollingDelay);
                        }
                        _redirectTo3dSecurePayment(result);
                    }
                } else {
                    //Show complete page
                    $location.path(String.format(completeUrl, cm.bookingId));
                }
            } else {
                const message = result.ReasonCode ? paymentDetailsService.getcardFailureReasonMessage(result.ReasonCode) : result.PaymentMessage;
                _handleFailurePayment(message, null);
            }
        }, function() {
            _showError(resourceService.get('PAYBALANCEERROR'));
        });

        mybTrack.track('MYB - Pay Balance', {
            PaymentType: cm.paymentModel.isPayPalPayment ? 'PayPal' : 'Card',
            PartPayment: !cm.payFull
        });
    };

    cm.closeCPG = function() {
        sessionStorage.removeItem('PaymentPopup');
        cm.threedsRedirecting = false;
    };

    cm.updateDfReferenceId = dfReferenceId => {
        cm.DfReferenceId = dfReferenceId;
        return cm.DfReferenceId;
    };

    cm.bypassThreeDS = function() {
        const data = {
            paRes: '',
            md: '',
            prePaymentId: threeDSecure.PrePaymentID
        };
        _authorisePayment(data, false);
    };

    function cpgValidationComplete(BookingId, PaymentId) {
        if (BookingId && PaymentId) {
            paymentDetailsService.getCpgStatus(BookingId, PaymentId).then(data => {
                if (data && data.error) {
                    _handleFailurePayment(data.error, null);
                }
            });
        }
    }

    //Watches
    $scope.$on('3DSValidationComplete', function(ev, data) {
        _authorisePayment(data, true);
    });

    $scope.$watch('cm.paymentAmount', function(val) {
        val = val && !isNaN(val) ? val : 0;
        cm.paymentAmountDecimal = parseFloat(val);
        _updateBlanceDueDetail();
    });

    $scope.$watch('cm.paymentModel.fee', () => {
        _updateBlanceDueDetail();
    });

    //Private methods
    function _formatClearRequestPayload() {
        let request = {
            BookingId: cm.bookingId,
            PaymentId: 0, //Default, As it is not existing payment.
            CurrencyCode: cm.currencyCode,
            Amount: cm.totalPaymentAmount,
            DomainId: TRPCONFIG.Domain.DomainId,
            CultureCode: TRPCONFIG.Domain.CultureCode,
            PayPalCallbackUrl: String.format(payPalCallbackUrl, root, '$PaymentId', cm.bookingId, 'success'),
            PayPalCancellationUrl: String.format(payPalCallbackUrl, root, 0, cm.bookingId, 'cancel'),
            ApplicationType: TRPCONFIG.ApplicationType,
            DfReferenceId: cm.DfReferenceId,
            ReturnUrl: String.format('{0}threedsecure?prePaymentID=', root),
        };

        //add in our payment details
        paymentsUtilService.addPaymentDetailsToClearRequest(cm.paymentModel, request);

        return request;
    }

    function _formatAuthoriseRequestPayload(data) {
        return {
            PaymentId: data.paymentId && data.paymentId.length ? data.paymentId : data.prePaymentId,
            PaRes: decodeURIComponent(data.paRes),
            MD: data.md,
            DomainId: TRPCONFIG.Domain.DomainId,
            CultureCode: TRPCONFIG.Domain.CultureCode
        };
    }

    function _authorisePayment(data, threeDSecure = false) {
        if (TRPCONFIG.Domain.DisableAuthorisePaymentCall) {
            _block(true);
            const paymentId = data.paymentId && data.paymentId.length ? data.paymentId : data.prePaymentId;
            paymentDetailsService.authorisePaymentByCPGStatus(cm.bookingId, paymentId).then(result => {
                if (threeDSecure) {
                    $scope.$broadcast('3DSValidationFinished', true);
                }
                if (result === 'SUCCESS') {
                    $location.path(String.format(completeUrl, cm.bookingId));
                } else {
                    _handleFailurePayment(result, data);
                }
                }, function() {
                _showError(resourceService.get('AUTHORISEEERROR'));
            });
        } else {
            _block(true);
            paymentDetailsService.authorisePayment(_formatAuthoriseRequestPayload(data)).then(function(result) {
                if (threeDSecure) {
                    $scope.$broadcast('3DSValidationFinished', result.Success);
                }

                if (result.Success) {
                    $location.path(String.format(completeUrl, cm.bookingId));
                } else {
                    _handleFailurePayment(result.PaymentMessage, data);
                }
            }, function() {
                _showError(resourceService.get('AUTHORISEEERROR'));
            });
        }

        $scope.$apply(function() {
            cm.threedsRedirecting = false;
        });
    }

    function _redirectTo3dSecurePayment(result) {
        //Create threeDSecure object
        threeDSecure = {
            PaReq: result.PaReq,
            MD: result.MD,
            TermUrl: String.format('{0}threedsecure?prePaymentID={1}', root, result.PaymentId),
            AcsUrl: result.AcsUrl,
            CanByPass: result.AllowThreeDSecureBypass,
            PrePaymentID: result.PaymentId
        };
        $scope.$broadcast('request3DSValidation', threeDSecure, {
            Journey: 'PostBooking',
            BookingID: cm.bookingId,
            SignedIn: currentUser.get().SignedIn
        });
        cm.threedsRedirecting = true;
        cm.ThreeDSecure = threeDSecure;
        broker.publish('unblock');
        $scope.$emit('unblock');
    }

    function _handleFailurePayment(msg, data) {
        const messages = [resourceService.get('PAYMENTFAILED') + msg, String.format(resourceService.get('PAYMENTASSISTENCE'), resourceService.get('TELEPHONENUMBER'))];
        if (data.paRes !== 'STOP') {
            _showError(messages);
        }
        broker.publish('unblock');
        $scope.$emit('unblock');
    }

    function _showError(msg) {
        $scope.$broadcast('flash:error', msg);
    }

    function _block(completing) {
        $scope.$emit('block', {
            title: resourceService.get(completing ? 'COMPLETINGPAYMENT' : 'PREPARINGPAYMENT'),
            loadingScreenStyle: 'default-payBalance'
        });
    }

    function _processBalanceDue(balanceDue) {
        _initDueDetails(balanceDue);
        _updateBlanceDueDetail();
        cm.BalanceDueDate = balanceDue.DueDate;
    }

    function _updateBlanceDueDetail() {
        cm.totalPaymentAmount = cm.paymentAmountDecimal + cm.paymentModel.fee;
        cm.balanceDueAfterPayment = cm.balanceDue - cm.paymentAmountDecimal;
    }

    function _initDueDetails(dueDetail) {
        if (!dueDetail) {
            //If there is no due amount redirect to booking reference page.
            $location.path(String.format(bookingReferenceUrl, cm.bookingId));
        } else {
            cm.balanceDue = dueDetail.BalanceDueAmount - dueDetail.PendingElvPayments;
            //cm.balanceDue = cm.balanceDue.toFixed(2);
            cm.currencyCode = dueDetail.ClientCurrencyCode;
            cm.paymentAmount = cm.balanceDue.toFixed(2);
            cm.paymentAmountDecimal = parseFloat(cm.paymentAmount);
        }
    }
}
})();
